import { findOrCreate } from "./find-or-create.js";
import { setConfig } from "./config/set.js";
import { rootNamespace } from "./root.js";
import { callConfig } from "./config/call.js";
/**
 * @typedef {import("../model/resource.js").ConfigCallback} ConfigCallback
 */
/**
 * @param {string} name
 * @param {Array<ConfigCallback>} configCallbacks
 */
export function createFeature(name, ...configCallbacks) {
    const resource = findOrCreate(rootNamespace, name);
    setConfig(resource, configCallbacks);
    callConfig(resource);
    return resource;
}
